export const Logo = ({ light = false, className = "" }) => (
  <span
    data-testid="vav-logo"
    className={`font-serif font-semibold leading-none select-none ${light ? "text-paper" : "text-ink"} ${className}`}
  >
    <span className="text-3xl md:text-4xl tracking-tighter">V</span>
    <span className="text-3xl md:text-4xl tracking-tighter italic text-sage -ml-1.5">A</span>
    <span className="text-3xl md:text-4xl tracking-tighter -ml-1.5">V</span>
  </span>
);
